import buildTransactionObj from "../investments/objects/build_transaction_obj";
import determineIfNewBuyTranRequired from "./determine_if_new_buy_tran_required";
import selectGameInvestmentType from "./select_game_investment_type";
import determineIfCurrentlyActive from "./determine_if_currently_active";
import checkIfHistoryUpdate from "./check_if_history_update";
import updateMaturityDateArr from "./update_maturity_date_arr";

export const buildUpdateGameInvestmentTranArr = (investType, currentDate, gameInvestments, 
        inputTranArr, gameDate, gameMonth, gameID, maturityDateArr) => {
    let dateAdded = currentDate;
    const gameInvestmentInfo = selectGameInvestmentType(gameInvestments, investType);
    const historyExists = gameInvestmentInfo.historyExists;
    let transactionNbr = gameInvestmentInfo.transactionNbr;
    let transactionArr = gameInvestmentInfo.transactionArr;
    let historyTranArr = gameInvestmentInfo.historyTranArr;
    let taxHistoryArr = gameInvestmentInfo.taxHistoryArr;
    if (gameInvestmentInfo.dateAdded){
        dateAdded = gameInvestmentInfo.dateAdded;
    }
    let cashChg = 0;
    for (let i=0; i<inputTranArr.length; i++){
        let createNewTran = true;
        const inputTran = inputTranArr[i];
        if (inputTran.tranType === "buy"){
            // new buy tran not required if there is already a buy tran with same game date 
            // (player has purchased shares/units of investment multiple times in same turn)
            // if a buy tran is found with current game date, then just add new buy quantity
            // to transaction array...
            if (transactionArr.length > 0){
                createNewTran = determineIfNewBuyTranRequired(transactionArr, gameDate, inputTran);
            }
            inputTran.totalAmount = +inputTran.totalAmount * -1;
        }
        if (createNewTran === true){
            transactionNbr += 1;
            const basicTranInfo = {shortName: inputTran.shortName, tranType: inputTran.tranType, 
                transactionNbr: transactionNbr, quantity: inputTran.quantity, unitPrice: inputTran.unitPrice,
                currentGameDate: gameDate, monthNbr: gameMonth
            }
            const transactionObj = buildTransactionObj(basicTranInfo);
            transactionArr.push(transactionObj);
            transactionNbr += 1;
            if (inputTran.coupon === true && inputTran.tranType === "sell" ){
                const basicTranInfo = {shortName: inputTran.shortName, tranType: "coupon", 
                    transactionNbr: transactionNbr, quantity: inputTran.quantity, 
                    unitPrice: inputTran.couponUnitPrice, currentGameDate: gameDate, monthNbr: gameMonth
                };
                const transactionObj = buildTransactionObj(basicTranInfo);
                transactionArr.push(transactionObj);
                cashChg += +inputTran.totalCouponAmt;
            }
        }
        cashChg += +inputTran.totalAmount;
    }
           
    let currentlyActive = determineIfCurrentlyActive(transactionArr, investType);
    const investHistoryObj = checkIfHistoryUpdate(gameDate, gameID, investType, historyTranArr, 
        historyExists );
    let gameInvestHistoryObj = {}
    if (historyExists === true){
        gameInvestHistoryObj = investHistoryObj;
    }
    let gameInvestmentObj = {gameID: gameID, investType: investType, currentlyActive: currentlyActive,
        transactionArr: transactionArr, historyTranArr: historyTranArr, historyExists: historyExists,
        taxHistoryArr: taxHistoryArr, dateUpdated: currentDate, dateAdded: dateAdded};
    if (investType === "bond"){
        const updatedMaturityDateArr = updateMaturityDateArr(maturityDateArr);
        gameInvestmentObj = {...gameInvestmentObj, maturityDateArr: updatedMaturityDateArr};
    }
    const returnObj={gameInvestHistoryObj: gameInvestHistoryObj, gameInvestmentObj: gameInvestmentObj,
        currentlyActive: currentlyActive,  cashChg: cashChg};
    return returnObj;
}
export default buildUpdateGameInvestmentTranArr;